module.exports = __webpack_public_path__ + "img/tab.77482468.jpg";